var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3532 14.5518C22.6556 14.2033 22.8862 13.7984 23.0317 13.3605C23.1772 12.9226 23.2348 12.4602 23.2011 12C22.2727 12.0749 21.4109 12.5116 20.8013 13.2159C20.5094 13.5535 20.2882 13.9462 20.1508 14.3708C20.0134 14.7953 19.9626 15.2432 20.0014 15.6878C20.4542 15.6915 20.9019 15.591 21.3097 15.3941C21.7176 15.1971 22.0746 14.9089 22.3532 14.5518ZM24.3691 20.5034C24.3744 19.8905 24.5359 19.289 24.8382 18.7557C25.1405 18.2225 25.5737 17.775 26.0969 17.4556C25.7667 16.9799 25.3302 16.5876 24.822 16.3099C24.3138 16.0321 23.7479 15.8767 23.1691 15.8557C21.9212 15.7278 20.7693 16.5837 20.1053 16.5837C19.4414 16.5837 18.5055 15.8717 17.4655 15.8877C16.7857 15.9101 16.1232 16.1084 15.5428 16.4631C14.9624 16.8178 14.4838 17.3168 14.1537 17.9116C12.7458 20.3594 13.7938 23.9992 15.2017 25.9751C15.8416 26.943 16.6416 28.0389 17.6975 27.9989C18.7534 27.9589 19.0974 27.343 20.3213 27.343C21.5452 27.343 21.9212 27.9989 22.9612 27.9749C24.0011 27.9509 24.737 26.983 25.409 26.0151C25.885 25.3123 26.2568 24.5444 26.5129 23.7352C25.8789 23.4649 25.3381 23.0147 24.9571 22.4404C24.5761 21.866 24.3716 21.1927 24.3691 20.5034Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton1);
export default __webpack_public_path__ + "static/media/_Button (1).d22738ce18c75ad36c055275751babe9.svg";
export { ForwardRef as ReactComponent };